module.exports = __webpack_public_path__ + "media/images/sp/lp/croud-dd19dcdaddaaa44481672c8c68f49380.png";